import React from 'react';
import { FadeIn } from '../components/FadeIn';
import { CtaButton } from '../components/CtaButton';
import { LockIcon, MailIcon, ShieldCheckIcon } from 'lucide-react';
export function HeroSection() {
  const scrollToValueStack = () => {
    const el = document.getElementById('value-stack-section');
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden px-6 py-16" data-id="element-227">
      {/* Breathing Background Animation */}
      <div className="absolute top-1/2 left-1/2 w-[600px] h-[600px] md:w-[800px] md:h-[800px] bg-lavender rounded-full blur-3xl animate-breathe pointer-events-none" data-id="element-228" />

      <div className="relative z-10 max-w-4xl mx-auto text-center flex flex-col items-center" data-id="element-229">
        <FadeIn delay={0.2} data-id="element-230">
          <h1 className="font-playfair text-4xl md:text-5xl lg:text-6xl font-bold text-warmwhite leading-tight mb-8" data-id="element-231">
            Neutralize the Surge Before You Snap.
            <br data-id="element-232" />
            <span className="text-rosegold" data-id="element-233">
              Master Your Emotional Architecture in Exactly 55 Seconds
            </span>
          </h1>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-234">
          <p className="font-inter text-lg md:text-xl text-lavender max-w-2xl mx-auto mb-12 leading-relaxed" data-id="element-235">
            The moment anger takes over — your heart races, your hands shake,
            and you say things you can't take back. What if you could stop all
            of it in 55 seconds — without meditating, without counting to ten,
            without leaving the room?
          </p>
        </FadeIn>

        <FadeIn delay={0.4} className="w-full flex flex-col items-center" data-id="element-236">
          <CtaButton text="Yes — I Want To Stop The Rage Instantly →" onClick={scrollToValueStack} className="mb-8 w-full md:w-auto md:min-w-[400px]" data-id="element-237" />

          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-3 font-inter text-sm md:text-base mt-2" data-id="element-238">
            <span className="flex items-center text-rosegold font-semibold drop-shadow-[0_0_12px_rgba(201,169,110,0.9)]" data-id="element-239">
              <LockIcon className="w-4 h-4 mr-2 text-rosegold" data-id="element-240" /> Secure Payment
            </span>
            <span className="text-rosegold/60 font-bold" data-id="element-241">•</span>
            <span className="flex items-center text-rosegold font-semibold drop-shadow-[0_0_12px_rgba(201,169,110,0.9)]" data-id="element-242">
              <MailIcon className="w-4 h-4 mr-2 text-rosegold" data-id="element-243" /> Instant Email
              Access
            </span>
            <span className="text-rosegold/60 font-bold" data-id="element-244">•</span>
            <span className="flex items-center text-rosegold font-semibold drop-shadow-[0_0_12px_rgba(201,169,110,0.9)]" data-id="element-245">
              <ShieldCheckIcon className="w-4 h-4 mr-2 text-rosegold" data-id="element-246" /> 7-Day
              Money Back Guarantee
            </span>
          </div>
        </FadeIn>
      </div>
    </section>;
}